import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { Button } from '@mui/material';
import React from 'react';

import styles from './styles.module.scss';

interface NoCareAvailableProps {
  upcomingAppointment: boolean;
  hasUpcomingAppointment?: boolean;
}

const NoCareAvailable = ({ upcomingAppointment, hasUpcomingAppointment }: NoCareAvailableProps): JSX.Element => {
  const roleNavigate = useRoleNavigate();

  const message = upcomingAppointment
    ? 'You have no upcoming appointments'
    : hasUpcomingAppointment
    ? "You haven't completed any services yet"
    : "You haven't had any care services yet";

  return (
    <div className={styles.noCareAvailableDiv}>
      <p>{message}</p>
      {!hasUpcomingAppointment && (
        <Button variant="contained" onClick={() => roleNavigate('./dashboard')}>
          Find Care
        </Button>
      )}
    </div>
  );
};
export default NoCareAvailable;
